import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView } from '@/components/base'
import { SearchInput } from '@/components/SearchInput'
import { DatePickerButton } from '@/components/DatePickerButton'
import { FilterTag } from '@/components/FilterTag'
import { RangeDate, TransactionTypes } from '@/domain/transactions'

interface ActivityFiltersProps {
  searchValue?: string
  onSearchChange: (value: string) => void
  selectedTypes: TransactionTypes[]
  onTypesChange: (types: TransactionTypes[]) => void
  dateRange: RangeDate
  onDateRangeChange: (range: RangeDate) => void
  onClearFilters?: () => void
  hasActiveFilters?: boolean
}

export const ActivityFilters: React.FC<ActivityFiltersProps> = ({
  searchValue,
  onSearchChange,
  selectedTypes,
  onTypesChange,
  dateRange,
  onDateRangeChange,
  onClearFilters,
  hasActiveFilters,
}) => {
  const { t } = useTranslation()

  const formatDateRange = () => {
    if (!dateRange.startDate || !dateRange.endDate) return ''

    // Форматирование даты в формат DD.MM.YYYY (как на изображении)
    const formatDate = (date: Date) => {
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}.${month}.${year}`
    }

    const startDateFormatted = formatDate(dateRange.startDate)
    const endDateFormatted = formatDate(dateRange.endDate)

    return `${startDateFormatted} - ${endDateFormatted}`
  }

  return (
    <BaseView px={0} py={12} gap={16}>
      {/* Search and Date Picker Row */}
      <BaseView row gap={8}>
        <BaseView flex={1}>
          <SearchInput
            value={searchValue}
            onChangeTextDebounced={onSearchChange}
            clean={() => onSearchChange('')}
            placeholder={t('form:placeholders.search')}
            withoutBorder
          />
        </BaseView>

        <DatePickerButton
          appliedRangeDate={dateRange}
          setAppliedRangeDate={onDateRangeChange}
        />
      </BaseView>

      {/* Filter Tags */}
      {dateRange.startDate && dateRange.endDate && (
        <FilterTag
          label={formatDateRange()}
          onDelete={() => onDateRangeChange({ startDate: null, endDate: null })}
        />
      )}
    </BaseView>
  )
}
